import React from "react";
import { UI_STYLES } from "../../styles/uiStyles";  
import { AppRoute } from "../../App"; 
import { useNavigate } from "react-router-dom";

interface SubscribeButtonsProps {
  buttonText?: string;
  telegramText?: string;
  onButtonClick?: () => void;
  onTelegramClick?: () => void;
  telegramHref?: string;
  className?: string;
}

const SubscribeButtons: React.FC<SubscribeButtonsProps> = ({
  buttonText = "Оформить подписку",
  telegramText = "Посетить Telegram астролога",
  className,
  onButtonClick,
  onTelegramClick,
  telegramHref = "#",
}) => {
  const navigate = useNavigate();
  return (
    <div className={`flex flex-col items-center w-full ${className} `}>
      <button
        className={`w-full max-w-xs ${UI_STYLES.buttonGradient} hover:bg-cyan-700 text-white  rounded-xl py-3 mb-2 transition`}
        onClick={onButtonClick || (() => navigate(AppRoute.Register))}
      >
        {buttonText}
      </button>
      <a
        href={telegramHref}
        className="w-full max-w-xs text-cyan-400 text-center text-sm underline mb-4 block "
        target="_blank"
        rel="noopener noreferrer"
        onClick={onTelegramClick}
      >
        {telegramText}
      </a>
    </div>
  );
};

export default SubscribeButtons; 
